import { gameStore } from '../store/gameStore';
import { gameMainDrawer } from '../game/drawers/gameMainDrawer';
import { jackpotIcons, jackpotIconsAnimationPosition } from '../enums/jackpotIcons';
import { updateExpiresCount } from './jackpotHelpers';
import { soundService } from '../services';
import { SoundTypes } from '../services/baseSoundService/soundService';

export const jackpotInitialState = (bonusSpinInfo) => {
  soundService.play(SoundTypes.JackpotBackground);
  gameStore.setJackpotAmountVisible(true);
  gameMainDrawer.jackpotBar.jackpotSceneTextureContainer.visible = true;
  gameMainDrawer.jackpotBar.jackpotTextureContainer.visible = false;
  gameMainDrawer.jackpotBar.resetJackpotSymbolsInteractive();
  gameMainDrawer.jackpotBar.openJackpotScene();

  updateExpiresCount(+new Date(bonusSpinInfo.bonusData.expireDate));
  jackpotIconsAnimationPosition.forEach((el) => {
    el.count = 0;
  });
  bonusSpinInfo?.bonusData?.jackpotResult?.forEach((el) => {
    gameMainDrawer.jackpotBar.jackpotSceneTextureContainers.children.forEach((spine) => {
      if (spine.id === el.index) {
        spine.play('open', false);
        spine.interactive = false;
        spine.isOpened = true;
        spine.buttonMode = false;
      }
    });
    gameMainDrawer.jackpotBar.jackpotSceneTextureContainers.children[
      gameMainDrawer.jackpotBar.jackpotSceneTextureContainers.children.length - 1
    ].children[el.index - 1].play('win', false);
    gameMainDrawer.jackpotBar.jackpotSceneTextureContainers.children[
      gameMainDrawer.jackpotBar.jackpotSceneTextureContainers.children.length - 1
    ].children[el.index - 1].visible = true;

    gameMainDrawer.jackpotBar.jackpotSceneTextureContainers.children[
      gameMainDrawer.jackpotBar.jackpotSceneTextureContainers.children.length - 1
    ].children[el.index - 1].skeleton.setSkinByName(jackpotIcons[el.jackpotCard]);
    if (jackpotIconsAnimationPosition[el.jackpotCard - 1].id === el.jackpotCard) {
      jackpotIconsAnimationPosition[el.jackpotCard - 1].count += 1;
    }
    if (jackpotIconsAnimationPosition[el.jackpotCard - 1].count <= 3) {
      gameMainDrawer.jackpotBar.jackpotMoveAnimation(
        gameMainDrawer.jackpotBar.jackpotSceneTextureContainers.children[
          gameMainDrawer.jackpotBar.jackpotSceneTextureContainers.children.length - 1
        ].children[el.index - 1],
        jackpotIconsAnimationPosition[el.jackpotCard - 1].positions[
          jackpotIconsAnimationPosition[el.jackpotCard - 1].count - 1
        ].x,
        jackpotIconsAnimationPosition[el.jackpotCard - 1].positions[
          jackpotIconsAnimationPosition[el.jackpotCard - 1].count - 1
        ].y,
        jackpotIconsAnimationPosition[el.jackpotCard - 1].count,
        el.jackpotCard
      );
    }

    gameMainDrawer.jackpotBar.jackpotSceneTextureContainers.children[0].children[
      el.index - 1
    ].visible = true;

    gameMainDrawer.jackpotBar.jackpotSceneTextureContainers.children[0].children[
      // eslint-disable-next-line no-unsafe-optional-chaining
      el?.index - 1
    ].play('win', false);

    gameMainDrawer.jackpotBar.jackpotSceneTextureContainers.children[0].children[
      // eslint-disable-next-line no-unsafe-optional-chaining
      el?.index - 1
    ].skeleton.setSkinByName(jackpotIcons[el?.jackpotCard]);
  });
};
